<template>
    <div>
        <br>
            <label for="productFilterEntityProperty" class="">{{attributes.name}}</label>
            <v-select
                label="label"
                v-model="attributes.selectedValue"
                @input="setAttribute(attributes)"
                :options="attributes.typeValues"
                :clearable="true"
                :value="attributes.selectedValue"
            ></v-select>
            <div v-if="attributes.appendedAttributes.length > 0"  v-for="childAttribute in attributes.appendedAttributes" class="child-attribute">
                <product-wizard-child :parent-active-attributes="childAttribute"></product-wizard-child>
            </div>
        </div>
</template>

<script type="text/javascript">
    import Vue from 'vue';
    import VueEvents from 'vue-events';
    import axios from 'axios';
    import select2 from 'select2';
    import vSelect from 'vue-select';
    // import childField from './product-wizard-child';

    Vue.use(VueEvents);

    export default {
        name: 'product-wizard-child',
        props: ['parentActiveAttributes'],
        components:{
            'v-select': vSelect,
            // 'product-wizard-child': childField
        },
        data() {
            return {
                attributes: this.parentActiveAttributes,
                child: null,
            }
        },
        watch: {
            parentActiveAttributes: function(newVal, oldVal) {
                this.attributes = this.parentActiveAttributes;
            }
        },
        mounted() {
        },
        methods: {
            setAttribute(thisAttribute) {
                thisAttribute.appendedAttributes = [];

                if (thisAttribute.selectedValue == null) {
                    return;
                }

                if (thisAttribute.selectedValue.nestedAttributes) {
                    thisAttribute.appendedAttributes.push(thisAttribute.selectedValue.nestedAttributes);
                }else{
                    if (thisAttribute.selectedValue.nested_id !== null) {
                        this.getChild(thisAttribute.selectedValue);
                    }
                }
            },
            getChild (selected) {
                return axios.get('/products/wizard/attributes/'+ selected.nested_id, {
                })
                .then(function (response) {
                    this.child = response.data;
                    var childData = [];
                    childData[0] = response.data;
                    this.attributes.appendedAttributes = childData;
                }.bind(this))
                .catch(function (error) {
                    console.log(error);
                }.bind(this));
            },
            findObjectByKey(array, key, value){
               for (var i = 0; i < array.length; i++) {
                   if (array[i][key] === value) {
                        var foundArray = array[i];
                            foundArray.index = i
                       return foundArray;
                   }
               }
               return null;
            },
            checkObjectExists(array, key, value){
               for (var i = 0; i < array.length; i++) {
                   if (array[i][key] === value) {
                       return false;
                   }
               }
               return true;
            },
        },
    };
</script>


<style  lang="scss">
    .create-product-wizard{
        .v-select {
            .dropdown-toggle .clear{
                display: block;
                font-weight: 300;
                color: white;
                padding: 0px 9px 1px 9px;
                background-color: #AB5755;
                border-top-right-radius: 4px;
                border-bottom-right-radius: 4px;
                border: 1px solid #6b3836;
            }
            .vs__actions{
                position: absolute;
                right: -6px;
                top: 0px;
                bottom: 0px;
                padding: 0;
                z-index: 2;
                top: 0px;
                bottom: 0px;
                padding: 0;
            }
        }
    }
</style>
